<template>
  <div id="project-one-landing-view">
    <project-one-header
      v-if="bikePackage && bikePackage.platform"
      :title="bp('chooseYourModel', bikePackage.platform.name)"
      :message="bikePackage.platform.copyText"
      :base-properties="bpData"
      class="grid-container"
    >
      <project-one-get-saved-config-form :base-properties="bpData" />
    </project-one-header>

    <project-one-model-selector :base-properties="bpData" />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import ProjectOneModelSelector from '@/projectOne/components/landing/ProjectOneModelSelector';
import ProjectOneHeader from '@/projectOne/components/shared/ProjectOneHeader';
import ProjectOneGetSavedConfigForm from '@/projectOne/components/landing/ProjectOneGetSavedConfigForm';

export default {
  name: 'ProjectOneLandingView',

  components: {ProjectOneModelSelector, ProjectOneHeader, ProjectOneGetSavedConfigForm},

  computed: {
    ...mapState('projectOne', ['bikePackage']),
  },
};
</script>

<style lang="scss" scoped>
#project-one-landing-view {
  display: grid;
  grid-template-rows: auto 1fr;
}
</style>
